
import { Component, computed, defineComponent, PropType } from 'vue';
import { PersonalOfferDiscountType, PersonalOfferItemPrice } from '@/b2c/shared/api/server-apis';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import RegularItemDiscountCampaign from '@/b2c/offers/ui/helpers/RegularItemDiscountCampaign.vue';
import RegularItemDiscountPromoCode from '@/b2c/offers/ui/helpers/RegularItemDiscountPromoCode.vue';
import RegularItemDiscountMyBoliaBoost from '@/b2c/offers/ui/helpers/RegularItemDiscountMyBoliaBoost.vue';
import useGlobalLabels from '@/shared/content/useGlobalLabels';
import { GlobalLabels } from '@/shared/content/site-context.store';
import RegularItemNonMemberPrice from '@/b2c/offers/ui/helpers/RegularItemNonMemberPrice.vue';

export default defineComponent({
    name: 'RegularItemPrice',
    components: {
        RegularItemNonMemberPrice,
        RegularItemDiscountCampaign,
        RegularItemDiscountPromoCode,
        RegularItemDiscountMyBoliaBoost,
    },
    props: {
        price: {
            type: Object as PropType<PersonalOfferItemPrice>,
            required: true,
        },
        quantity: {
            type: Number,
            required: false,
            default: 1,
        },
    },
    setup(props) {
        const labels = useBlockLabels();
        const globalLabels = useGlobalLabels(GlobalLabels.product);

        const getDiscountComponentByType = (type: PersonalOfferDiscountType): Component => {
            switch (type) {
            case PersonalOfferDiscountType.Campaign:
                return RegularItemDiscountCampaign;
            case PersonalOfferDiscountType.PromoCode:
                return RegularItemDiscountPromoCode;
            case PersonalOfferDiscountType.MyBoliaBoost:
                return RegularItemDiscountMyBoliaBoost;
            }
        };

        const hasMyBoliaBoostDiscount = computed(() => {
            return props.price.discounts?.find((discount) => discount.type === PersonalOfferDiscountType.MyBoliaBoost);
        });

        return {
            labels,
            globalLabels,
            hasMyBoliaBoostDiscount,
            getDiscountComponentByType,
        };
    },
});
